import React, { Component } from "react"
import M from "materialize-css"

import ApiService from "../../services/api"
import configs from "../../../configs.json"
import Loading from "../loading/loading"

const apiservice = new ApiService()

class Transcriptions extends Component {
    constructor(props) {
        super(props)
        this.state = {
            redirect: null,
            loading: false,
            transcriptions: [],
            file: null,
            sourceLanguage: "pt",
            targetLanguage: "pt",
            outputType: "transcription",
        }
        this.handleSubmit = this.handleSubmit.bind(this)
        this.getAuth = this.getAuth.bind(this)
        this.loadTranscriptions = this.loadTranscriptions.bind(this)
    }

    showToast(message, classes = "red darken-2") {
        M.toast({ html: message, classes })
    }

    componentDidMount() {
        this.getAuth()
    }

    getAuth() {
        const user = localStorage.getItem("user")
        const token = localStorage.getItem("token")

        const req = new FormData()
        req.append("user", user)
        req.append("token", token)

        apiservice
            .hasAuth(req)
            .then((res) => {
                if (res.auth === "User" || res.auth === "Client") {
                    this.setState({ redirect: false }, () => {
                        this.loadTranscriptions()
                    })
                    return
                }
                this.setState({ redirect: true })
            })
            .catch(() => {
                this.setState({ redirect: true })
            })
    }

    loadTranscriptions() {
        apiservice
            .listTranscriptions()
            .then((response) => {
                this.setState({ transcriptions: response.results || [] })
            })
            .catch(() => {
                this.showToast("Nao foi possivel carregar as transcricoes.")
            })
    }

    handleSubmit(event) {
        event.preventDefault()

        if (!this.state.file) {
            this.showToast("Selecione um arquivo de audio ou video.")
            return
        }
        if (!this.state.file.type.startsWith("audio/") && !this.state.file.type.startsWith("video/")) {
            this.showToast("Formato invalido. Envie apenas audio ou video.")
            return
        }
        if (this.state.file.size > 200 * 1024 * 1024) {
            this.showToast("Arquivo muito grande. Limite de 200MB.")
            return
        }

        this.setState({ loading: true })

        const data = new FormData()
        data.append("file", this.state.file)
        data.append("source_language", this.state.sourceLanguage)
        data.append("target_language", this.state.targetLanguage)
        data.append("output_type", this.state.outputType)

        apiservice
            .createTranscription(data)
            .then((response) => {
                if (response.status === "completed") {
                    this.showToast("Transcricao concluida com sucesso.", "green darken-2")
                } else if (response.status === "failed") {
                    this.showToast("Falha ao processar a transcricao.")
                } else {
                    this.showToast("Transcricao criada com sucesso.", "green darken-2")
                }
                this.setState({ loading: false, file: null })
                this.loadTranscriptions()
            })
            .catch((error) => {
                const message = error?.response?.data?.error || "Falha ao enviar transcricao."
                this.showToast(message)
                this.setState({ loading: false })
            })
    }

    downloadItem(transcriptionId, type) {
        apiservice
            .downloadTranscription(transcriptionId, type)
            .then((blobData) => {
                const extension = type === "subtitles" ? "srt" : "txt"
                const fileName = `${transcriptionId}.${extension}`
                const url = window.URL.createObjectURL(new Blob([blobData]))
                const link = document.createElement("a")
                link.href = url
                link.setAttribute("download", fileName)
                document.body.appendChild(link)
                link.click()
                link.remove()
                window.URL.revokeObjectURL(url)
            })
            .catch(() => {
                this.showToast("Nao foi possivel baixar o arquivo.")
            })
    }

    deleteItem(transcriptionId) {
        apiservice
            .deleteTranscription(transcriptionId)
            .then(() => {
                this.showToast("Transcricao removida.", "green darken-2")
                this.loadTranscriptions()
            })
            .catch(() => {
                this.showToast("Nao foi possivel remover a transcricao.")
            })
    }

    render() {
        if (this.state.redirect === true) {
            window.location.replace(process.env.REACT_APP_URL)
            return null
        }

        if (this.state.redirect === null) {
            return <Loading />
        }

        return (
            <div className="container" id="transcriptions" style={{ backgroundColor: configs.colors.light }}>
                <div className="row section-row">
                    <h3 style={{ color: configs.colors.primary }}>Transcricoes e Legendas</h3>
                    <h6 style={{ color: configs.colors.dark }}>
                        Envie videos ou audios para gerar transcricao e legendas.
                    </h6>
                </div>

                <div className="card-panel" style={{ backgroundColor: configs.colors.offwhite }}>
                    <form onSubmit={this.handleSubmit}>
                        <div className="row">
                            <div className="col s12 m6">
                                <label>Arquivo</label>
                                <input
                                    type="file"
                                    accept="audio/*,video/*"
                                    onChange={(e) => this.setState({ file: e.target.files?.[0] || null })}
                                    required
                                />
                            </div>
                            <div className="col s12 m2">
                                <label>Idioma origem</label>
                                <select
                                    className="browser-default"
                                    value={this.state.sourceLanguage}
                                    onChange={(e) => this.setState({ sourceLanguage: e.target.value })}
                                >
                                    <option value="pt">Português</option>
                                    <option value="en">English</option>
                                    <option value="es">Español</option>
                                </select>
                            </div>
                            <div className="col s12 m2">
                                <label>Idioma destino</label>
                                <select
                                    className="browser-default"
                                    value={this.state.targetLanguage}
                                    onChange={(e) => this.setState({ targetLanguage: e.target.value })}
                                >
                                    <option value="pt">Português</option>
                                    <option value="en">English</option>
                                    <option value="es">Español</option>
                                </select>
                            </div>
                            <div className="col s12 m2">
                                <label>Saida</label>
                                <select
                                    className="browser-default"
                                    value={this.state.outputType}
                                    onChange={(e) => this.setState({ outputType: e.target.value })}
                                >
                                    <option value="transcription">Transcricao</option>
                                    <option value="subtitles">Legendas</option>
                                    <option value="both">Ambos</option>
                                </select>
                            </div>
                        </div>

                        <button
                            type="submit"
                            className="btn waves-effect waves-light hoverable"
                            style={{ backgroundColor: configs.colors.secondary }}
                            disabled={this.state.loading}
                        >
                            {this.state.loading ? "Enviando..." : "Processar"}
                            <i className="material-icons right">send</i>
                        </button>
                    </form>
                </div>

                <div className="row section-row">
                    <div style={{ marginBottom: "12px" }}>
                        <button
                            type="button"
                            className="btn-small"
                            style={{ backgroundColor: configs.colors.secondary }}
                            onClick={this.loadTranscriptions}
                        >
                            Atualizar lista
                        </button>
                    </div>
                    {this.state.transcriptions.length === 0 ? (
                        <p>Nenhuma transcricao encontrada.</p>
                    ) : (
                        this.state.transcriptions.map((item) => (
                            <div className="col s12" key={item.id}>
                                <div className="card-panel" style={{ backgroundColor: configs.colors.offwhite }}>
                                    <h6 style={{ marginTop: 0 }}>
                                        <strong>{item.filename}</strong>
                                    </h6>
                                    <p>Status: {item.status}</p>
                                    <p>Tipo: {item.output_type}</p>
                                    {item.error_message ? <p>Erro: {item.error_message}</p> : null}
                                    <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                                        <button
                                            type="button"
                                            className="btn-small"
                                            style={{ backgroundColor: configs.colors.secondary }}
                                            onClick={() => this.downloadItem(item.id, "transcription")}
                                            disabled={item.status !== "completed"}
                                        >
                                            Baixar TXT
                                        </button>
                                        <button
                                            type="button"
                                            className="btn-small"
                                            style={{ backgroundColor: configs.colors.secondary }}
                                            onClick={() => this.downloadItem(item.id, "subtitles")}
                                            disabled={item.status !== "completed"}
                                        >
                                            Baixar SRT
                                        </button>
                                        <button
                                            type="button"
                                            className="btn-small red darken-2"
                                            onClick={() => this.deleteItem(item.id)}
                                        >
                                            Excluir
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        )
    }
}

export default Transcriptions
